// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader__QNo75"};